import { IRootState } from "..";

const getLocale = (state: IRootState) => state?.i18n?.locale;

export { getLocale };
